import React from "react";
import { Heading, styled } from "@sourceful/shared-components";
import StandardHead from "@components/standardHead/StandardHead";
import { getSanityImgUrl } from "@lib/sanity";
import { format } from "date-fns";
import { BasicPageProps } from "pages/legal/[slug]";
import { BlockContent } from "@lib/sanity-components";

const PageWrapper = styled("div", {
  display: "block",
  maxWidth: "1200px",
  margin: "auto",
  paddingTop: "80px",
  paddingLeft: "20px",
  paddingRight: "20px",
  "@xl": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
});

const Updated = styled("div", {
  paddingTop: "20px",
  paddingBottom: "50px",
});

const BasicPage = ({ page }: BasicPageProps) => {
  const { metaDescription, metaTitle, openGraphImage, name, updated, content, disableCrawl } = page;
  return (
    <PageWrapper>
      <StandardHead
        title={metaTitle || name}
        metadescription={metaDescription}
        openGraph={{
          image: openGraphImage ? getSanityImgUrl(openGraphImage?.asset._ref) : undefined,
        }}
        disableCrawl={disableCrawl}
      />
      <Heading level={1} fontSize={2}>
        {name}
      </Heading>
      <Updated>Last updated: {format(new Date(updated), "MMM do, yyyy")}</Updated>
      <BlockContent value={content} />
    </PageWrapper>
  );
};

export default BasicPage;
